var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "busca",
    clipPath: "url(#clip0_12_71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M118.69 20.3299C105.655 7.29319 87.9744 -0.0312889 69.5386 -0.0322265C51.1029 -0.033164 33.4218 7.28952 20.3851 20.3249C7.34836 33.3603 0.0238871 51.0406 0.0229493 69.4764C0.0220115 87.9121 7.34469 105.593 20.3801 118.63C51.8601 150.12 92.6901 137.14 107.18 128.53L150.3 171.66C157 178.35 166.43 179.76 173.12 173.07C179.81 166.38 178.4 156.94 171.71 150.25L128.6 107.14C137.23 92.6699 150.18 51.8199 118.69 20.3299ZM110.41 110.33C102.327 118.414 92.0277 123.919 80.8156 126.149C69.6034 128.38 57.9816 127.235 47.4199 122.86C36.8582 118.486 27.831 111.077 21.4797 101.572C15.1285 92.0669 11.7385 80.8918 11.7385 69.4599C11.7385 58.0281 15.1285 46.8529 21.4797 37.3477C27.831 27.8425 36.8582 20.4341 47.4199 16.0595C57.9816 11.6848 69.6034 10.5403 80.8156 12.7707C92.0277 15.0011 102.327 20.5062 110.41 28.5899C121.232 39.4385 127.31 54.1364 127.31 69.4599C127.31 84.7834 121.232 99.4813 110.41 110.33Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177.49,
    height: 177.44,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusca);
export default __webpack_public_path__ + "static/media/busca.23b21b954a76c0d312e1f6c17fd1ef74.svg";
export { ForwardRef as ReactComponent };